class Translator {
    static getTranslation(translations, languages) {
        var _a;
        const userTranslation = translations.find((description) => description.languageCode.toLowerCase() ===
            languages.userLanguageCode.toLowerCase());
        const propertyTranslation = !!languages.propertyLanguageCode
            ? translations.find((description) => {
                var _a;
                return description.languageCode.toLowerCase() ===
                    ((_a = languages.propertyLanguageCode) === null || _a === void 0 ? void 0 : _a.toLowerCase());
            })
            : undefined;
        const englishTranslation = languages.fallbackLanguageCode
            ? translations.find((description) => {
                var _a;
                return description.languageCode.toLowerCase() ===
                    ((_a = languages.fallbackLanguageCode) === null || _a === void 0 ? void 0 : _a.toLowerCase());
            })
            : translations.find((description) => description.languageCode.toLowerCase() === 'en');
        return (_a = userTranslation !== null && userTranslation !== void 0 ? userTranslation : propertyTranslation) !== null && _a !== void 0 ? _a : englishTranslation;
    }
}

export { Translator as T };
//# sourceMappingURL=translator-c311ba49.js.map
